import { useEffect, useRef } from 'react';
import { useMap } from 'react-leaflet';

import L from 'leaflet';
import 'leaflet.fullscreen/Control.FullScreen.css';
import 'leaflet.fullscreen/Control.FullScreen.js';

import { FULLSCREEN_CONTROL_POSITION } from '../../components/Maps/constants';

export default function useFullscreen() {
  const map = useMap();
  const controlRef = useRef(null);

  useEffect(() => {
    if (!map || controlRef.current) return;

    const control = L.control.fullscreen({
      position: FULLSCREEN_CONTROL_POSITION,
      title: 'Open fullscreen',
      titleCancel: 'Exit fullscreen',
      forceSeparateButton: false
    });

    control.addTo(map);
    controlRef.current = control;

    // return () => {
    //   if (map && controlRef.current) {
    //     map.removeControl(controlRef.current);
    //     controlRef.current = null;
    //   }
    // };
  }, []);
}
